let $ = require('jquery');
let Vue = require('vue');

Vue.directive('jasny-file-input', {
    priority: 1000,
    params: [],
    bind: function () {
        $(this.el).fileinput();
    },
    update: function (value) {
    },
    unbind: function () {
    }
});




// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/jasny-file-input.js